// extracted by mini-css-extract-plugin
export var phone = "_53-0";